import {DxDataGrid, type DxDataGridTypes} from "devextreme-vue/data-grid";
import {cancelButtonProps, saveButtonProps} from "@helpers/button-helper";
import type { ColumnLookup } from "devextreme/common/grids";
import {type ToolbarItem} from "devextreme/ui/popup";
import { useIntl } from "../services/i18n";
import { exportDataGrid } from 'devextreme/excel_exporter';
import * as ExcelJS from "exceljs";
import { saveAs } from 'file-saver';
import { Workbook } from "exceljs";
import type dxDataGrid from "devextreme/ui/data_grid";

export function makeEditPopupButton(type: "Save"|"Cancel", gridRef: DxDataGrid | undefined) : ToolbarItem {
    let opts;
    switch (type) {
        case "Save":
            opts = {...saveButtonProps(), onClick: () => gridRef?.instance?.saveEditData()};            
            break;
        case "Cancel":
            opts = {...cancelButtonProps(), onClick: () => gridRef?.instance?.cancelEditData()};
            break;
    }
    return {
        widget: 'dxButton',
        toolbar: 'bottom',
        location: 'after',
        options: opts
    }
} 


export function getDefaultGridProperties() : DxDataGrid {
    
    return {
        width: '100%',
        columnAutoWidth: true,
        rowAlternationEnabled: true,
        pager: {
            showInfo: false,
            showPageSizeSelector: true
        },
        paging: {
            pageSize: 10,
            
        },
        remoteOperations: {
            filtering: true,
            paging: true,
            sorting:true,
            summary:true,
            grouping:true,
            groupPaging:true
        },
        headerFilter: {
            visible: true
        },
        filterRow: {
            visible: true
        },
        filterPanel: {
            visible: false
        }
    }
}

export function getDefaultGridDetailProperties() : DxDataGrid {
    
    return {
        width: '100%',
        columnAutoWidth: true,
        rowAlternationEnabled: true,
        pager: {
            showInfo: false,
            showPageSizeSelector: true
        },
        paging: {
            pageSize: 10,
        },
        remoteOperations: {
            filtering: true,
            paging: true,
            sorting:true,
            summary:true,
            grouping:true,
            groupPaging:true
        },
        headerFilter: {
            visible: true
        },
        filterRow: {
            visible: true
        },
        filterPanel: {
            visible: false
        }
    }
}

export function getLookup(entity: string, field: string) : ColumnLookup{
    const intl = useIntl();
    //@ts-ignore
    const keys = Object.keys(intl.i18n.messages.value[intl.i18n.locale.value][entity][field]);
    let dataSource = keys.map(key => ({
        value: key,
        text: intl.i18n.t(`${entity}.${field}.${key}`)
    }));
    
    return {
        dataSource: dataSource,
        valueExpr: "value",
        displayExpr: "text"
    }
}

export async function refresh(grid: dxDataGrid): Promise<void> {
    await grid.refresh();
}

export async function reset(grid: dxDataGrid): Promise<void> {
    grid.clearFilter();
    grid.clearGrouping();
    grid.clearSelection();
    // grid.clearSorting();
}

export async function exportToExcel(e: DxDataGridTypes.ExportingEvent, fileName: string): Promise<void> {
    const dataGrid = e.component;
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Hoja 1");

    await exportDataGrid({
        component: dataGrid,
        worksheet: worksheet,
        autoFilterEnabled: true, // Agregar filtros automáticos en Excel
    });

    const buffer = await workbook.xlsx.writeBuffer();
    saveAs(new Blob([buffer]), fileName + ".xlsx");
}

export async function getSelectedRow(grid: dxDataGrid): Promise<any>{
    return await grid.getSelectedRowsData()[0];
}